import React, { useEffect, useState } from 'react';
import axios from 'axios';

const RemoveBg = () => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [outputImage, setOutputImage] = useState(null);
    const [loading, setLoading] = useState(false);
    const [selectedBgColor, setSelectedBgColor] = useState('white');

    const handleFileChange = (e) => {
        setSelectedFile(e.target.files[0]);
        setOutputImage(null);
    };

    const handleRemoveBackground = async () => {
        if (!selectedFile) return alert("Please select an image first.");

        const formData = new FormData();
        formData.append("image_file", selectedFile);
        formData.append("size", "auto");

        setLoading(true);

        try {
            const response = await axios.post(
                "https://api.remove.bg/v1.0/removebg",
                formData,
                {
                    headers: {
                        "X-Api-Key": "5NcB3C6zKs7mKSsHRU1gBpV1", // ⚠ Replace with your own key
                        "Content-Type": "multipart/form-data",
                    },
                    responseType: "blob",
                }
            );

            const imageUrl = URL.createObjectURL(response.data);
            setOutputImage(imageUrl);
        } catch (error) {
            console.error("Error removing background:", error);
            alert("Background removal failed.");
        } finally {
            setLoading(false);
        }
    };

    const downloadWithBgColor = () => {
        if (!outputImage) return;

        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.src = outputImage;

        img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext('2d');

            ctx.fillStyle = selectedBgColor;
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(img, 0, 0);

            const finalImageUrl = canvas.toDataURL('image/png');
            const link = document.createElement('a');
            link.href = finalImageUrl;
            link.download = 'with-background.png';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        };
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="container py-5 every_page_mg_top">
            <div className="row align-items-center">
                <div className="col-md-6 text-center">
                    <img src="../images/coddingzone3.png" alt="Remove BG" className="img-fluid" style={{ maxHeight: "200px" }} />
                    <h1 className="mt-4 fw-bold">Remove Image<br />Background</h1>
                    <p className="fs-5">100% Automatically and <span className="text-warning bg-warning-subtle rounded px-2">Free</span></p>
                </div>

                <div className="col-md-6">
                    <div className="upload-box">
                        <input type="file" accept="image/*" className="paynow_btn text-white" onChange={handleFileChange} style={{ width: '220px' }} /><br /><br />
                        <button className='paynow_btn text-white' onClick={handleRemoveBackground} disabled={loading}>
                            {loading ? "Processing..." : "Remove Background"}
                        </button>

                        {outputImage && (
                            <div style={{ marginTop: '20px' }}>
                                <h3>Result:</h3>

                                <div className="mb-3">
                                    <strong>Select Background:</strong><br />
                                    {['white', 'black', 'red', 'green', 'blue'].map(color => (
                                        <button
                                            key={color}
                                            onClick={() => setSelectedBgColor(color)}
                                            style={{
                                                backgroundColor: color,
                                                color: color === 'white' ? 'black' : 'white',
                                                margin: '5px',
                                                border: 'none',
                                                padding: '6px 12px',
                                                cursor: 'pointer',
                                                borderRadius: '4px'
                                            }}
                                        >
                                            {color.charAt(0).toUpperCase() + color.slice(1)}
                                        </button>
                                    ))}
                                </div>

                                <div style={{
                                    backgroundColor: selectedBgColor,
                                    display: 'inline-block',
                                    padding: '10px'
                                }}>
                                    <img src={outputImage} alt="No background" style={{ maxWidth: '100%' }} />
                                </div>
                                <br />

                                <button className='paynow_btn text-white mt-3' onClick={downloadWithBgColor}>
                                    Download with Background
                                </button>
                            </div>
                        )}

                        <p className="mt-3">or drop a file,<br />
                            paste image or <a href="#">URL</a></p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RemoveBg;